export enum Environment {
  Development = 'development', //a.k.a. Stage, a.k.a. Localhost
  Production = 'production', //a.k.a. Demo
  AzureUAT = 'azureUAT',
  AzureProd = 'azureProd',
}
